import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

/**
 * Renders children into a detached node appended to `container` (default document.body).
 * Used by every overlay in the kit so nothing is clipped by an ancestor's overflow.
 */
const Portal = ({ children, container, disabled = false }) => {
  const [host, setHost] = useState(null)

  useEffect(() => {
    if (disabled) return undefined
    const target = container || document.body
    const node = document.createElement('div')
    node.setAttribute('data-kit-portal', '')
    target.appendChild(node)
    setHost(node)
    return () => {
      target.removeChild(node)
      setHost(null)
    }
  }, [container, disabled])

  if (disabled) return children
  if (!host) return null
  return createPortal(children, host)
}

export default Portal
